import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=2b0611c6&"
import script from "./LogoutDialog.vue?vue&type=script&lang=ts&"
export * from "./LogoutDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports